module.exports = __webpack_public_path__ + "static/po-intro-img-1-ebc782920bc584c5281634361885a075.png";